import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import Report from '../../../../common/components/Report';

const PredesOriginImpcCodeNotRegisteredReport = props => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.PREDES_ORIGIN_IMPC_CODE_NOT_REGISTERED_SUMMARY.id,
        label: 'Summary',
      },
      {
        value: ReportDefinitions.PREDES_ORIGIN_IMPC_CODE_NOT_REGISTERED_DETAILS.id,
        label: 'Details',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.summary.report',
      },
    ]}
    {...props}
  />
);
export default PredesOriginImpcCodeNotRegisteredReport;

PredesOriginImpcCodeNotRegisteredReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
};
